import React from 'react';

import ReactTable from 'components/ReactTable/ReactTable.js';

import { nInt } from 'hooks/Pipe';
import { Link } from 'react-router-dom';
import { Visibility } from '@material-ui/icons';

const columns = [
  { Header: '#', accessor: 'num', width: 120 },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 130 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Stock Disp.', accessor: 'available', width: 130, align: 'center' },
  { Header: 'Cantidad / 7', accessor: 'quantity_7', width: 130, align: 'center' },
  { Header: 'Promedio / día', accessor: 'avg_quantity_7', width: 150, align: 'center' },
  { Header: 'Días restantes', accessor: 'dias_stock_aprox', width: 130, align: 'center' },
  { Header: '', accessor: 'actions', width: 0 },
];

export default function TableListStock({ data = [], show = false }) {
  return (
    <ReactTable
      excelName="Líneas"
      defaultWidth={1300}
      columns={columns}
      exportExcel={false}
      colorRow={(item) => {
        let color = '';
        if (item.dias_stock_aprox <= 1) {
          color = '#ff00001f';
        } else if (item.dias_stock_aprox <= 3) {
          color = '#ffbb3f5c';
        } else if (item.dias_stock_aprox <= 6) {
          color = '#fcff3f5c';
        } else if (item.dias_stock_aprox <= 10) {
          color = '#00d11a45';
        }
        return color;
      }}
      data={data.map((item, i) => {
        return {
          num: !show ? (
            i + 1
          ) : (
            <div className="actions-right">
              {i + 1}
              <Link to={`${item.logi_product_id}`}>
                <Visibility fontSize="small" />
              </Link>
            </div>
          ),
          ItemCode: item.ItemCode,
          ItemName: item.ItemName,
          WhsName: `${item.WhsCode || ''} - ${item.WhsName || ''}`,
          available: nInt(item.available),
          quantity_7: nInt(item.quantity_7),
          avg_quantity_7: nInt(item.avg_quantity_7),
          dias_stock_aprox: item.dias_stock_aprox,
          actions: '',
        };
      })}
    />
  );
}
